/* script */
//
//
//
//
//
//
//
//
//

// Components
import EmailingExportLogs from 'shared/ui/components/listings/custom-actions/EmailingExportLogs.vue';
import OpenModalAction from 'shared/ui/components/listings/custom-actions/OpenModalAction.vue';
import UploadButton from 'shared/ui/components/uploader/UploadButton.vue';
import ListExportModal from 'shared/ui/components/modals/ListExportModal.vue';
import FpTypeExportModal from 'shared/ui/components/modals/FpTypeExportModal.vue';

const __vue_script__ = {
    name: 'ListActions',

    components: {
        EmailingExportLogs,
        OpenModalAction,
        UploadButton
    },

    props: {
        controller: {
            type: Object,
            required: true
        },

        event: {
            type: Object,
            required: true
        },

        module: {
            type: Object,
            required: true
        },

        metadata: {
            type: Object,
            required: true
        }
    },

    data() {
        const { resolvers, routeOptions } = this.controller;
        const { crudOpts = {} } = routeOptions || {};
        const defaultResolver = resolvers.default || {};
        const { options: resolverOptions = {} } = defaultResolver;
        const { fpType } = resolverOptions;

        return {
            actions: [],
            crudOpts,
            fpType,
            showExportButton: !crudOpts.hideExport,
            useBackendExport: crudOpts.use_backend_download
        };
    },

    computed: {
        showImportButton() {
            const importRoute = Boolean(this.$services.blueprint.gtFpTypeRoute(this.fpType, 'import'));
            return this.crudOpts.hasOwnProperty('importPathOverride') || importRoute;
        }
    },

    created() {
        this.init();
    },

    methods: {
        init() {
            const ctas = this.controller.routeOptions?.callToActions || [];
            this.actions = ctas.map(cta => this.createAction(cta)).filter(Boolean);
        },

        /**
         * Creates an action based on the provided call-to-action (cta) object.
         *
         * @param {Object} cta - The call-to-action object containing details for the action.
         *
         * @returns {Object} The created action object.
         */
        createAction(cta) {
            const { controllerKey, label, link, primary, component, props, moduleName, modal } = cta;

            if (modal) {
                return this.createModalAction(modal, label, primary, props);
            } else if (controllerKey) {
                const module = moduleName ? this.$services.blueprint.getModuleByName(moduleName) : this.module;
                return this.createControllerAction(module, controllerKey, label, primary);
            } else if (link?.fileName?.length) {
                return this.createLinkAction(link, label, primary);
            } else if (component) {
                return this.createComponentAction(component, label, primary, props);
            } else {
                console.error('[CallToActions] Defined an invalid call to action: ', cta);
            }
        },

        /**
         * Creates a modal action with the specified parameters.
         *
         * @param {Object} modal - The modal object to be used for the action.
         * @param {string} label - The label for the modal action.
         * @param {boolean} primary - Indicates if the action is primary.
         * @param {Object} [props] - Additional properties for the modal action.
         * @param {boolean} [props.modelIdParam] dynamically add a model ID from route parameters.
         */
        createModalAction(modal, label, primary, props) {
            const commons = this.commonLinkProps(label, primary);
            commons.classes = `btn ${commons.classes}`;

            if (props?.modelIdParam) {
                const { modelId } = this.$router.getRouteParams();
                modal.props = { ...modal.props, [props.modelIdParam]: modelId };
            }

            return {
                component: OpenModalAction,
                props: {
                    event: this.event,
                    component: modal.component,
                    ...commons,
                    props: {
                        ...modal.props,
                    },
                    onDone: () => this.$emit('reload')
                }
            };
        },

        /**
         * Creates a controller action for a given module and controller key.
         *
         * @param {string} module - The module to which the controller action belongs.
         * @param {string} controllerKey - The key identifying the controller.
         * @param {string} label - The label for the action.
         * @param {boolean} primary - Indicates if the action is primary.
         *
         * @returns {Object} The created controller action.
         */
        createControllerAction(module, controllerKey, label, primary) {
            const navItem = this.$services.blueprint.getControllerByName(module.name, controllerKey);
            if (navItem?.route && label) {
                return {
                    ...this.commonLinkProps(label, primary),
                    link: this.$utils.modules.getRouteHref(module, controllerKey, { eventId: this.event._id }),
                };
            }
        },

        /**
         * Creates a link action with the specified parameters.
         *
         * @param {string} link - The URL or path for the link.
         * @param {string} label - The label or text for the link.
         * @param {boolean} primary - Indicates if the link is a primary action.
         *
         * @returns {Object} The link action object.
         */
        createLinkAction(link, label, primary) {
            return {
                ...this.commonLinkProps(label, primary),
                link: this.$utils.assets.getEventAssetPath(this.event._id, link.fileName),
                target: link.target
            };
        },

        /**
         * Creates a component action with the specified parameters.
         *
         * @param {Object} component - The Vue component to be used for the action.
         * @param {string} label - The label for the action.
         * @param {boolean} primary - Indicates if the action is primary.
         * @param {Object} props - The properties to be passed to the component.
         *
         * @returns {Object} The created component action.
         */
        createComponentAction(component, label, primary, props) {
            return {
                ...this.commonLinkProps(label, primary),
                component,
                props
            };
        },

        /**
         * Generates common properties for a link component.
         *
         * @param {string} label - The label for the link.
         * @param {boolean} primary - Indicates if the link is primary.
         *
         * @returns {Object} The common properties for the link component.
         */
        commonLinkProps(label, primary) {
            return {
                label: this.$te(label) ? this.$t(label) : label,
                classes: primary ? 'btn-primary' : ''
            };
        },

        /**
         * Opens the export users list modal
         */
        openExportModal() {
            const exportModalType = this.useBackendExport ? FpTypeExportModal : ListExportModal;
            this.$modal.show(exportModalType, {
                title: this.$utils.strings.humanizeType(this.metadata, this.fpType, true),
                immediateDownload: true,
                fpType: this.fpType,
                event: this.event,
                exporter: this.crudOpts.exportPathOverride,
                showFields: false
            }, {
                classes: 'small',
                height: 'auto',
                clickToClose: false
            });
        },

        /**
         * @returns {string} the HREF for the users list import
         */
        getExcelImportHref() {
            if (this.crudOpts.importPathOverride) {
                return this.$utils.url.getImportExportHref(this.crudOpts.importPathOverride, this.event._id, 'event');
            } else {
                return this.$utils.modules.getRouteHref(this.module, 'import', {
                    eventId: this.event._id
                });
            }
        },
    }

};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.actions.length || _vm.showExportButton || _vm.showImportButton)?_c('div',{staticClass:"list-actions"},[_vm._l((_vm.actions),function(action){return [(action.component)?_c(action.component,_vm._b({tag:"component",attrs:{"event":_vm.event}},'component',action.props,false)):_c('a',{staticClass:"btn",class:[action.classes],attrs:{"href":action.link,"target":action.target}},[_vm._v(_vm._s(action.label))])]}),(_vm.showExportButton)?_c('a',{staticClass:"btn",on:{"click":function($event){return _vm.openExportModal()}}},[_vm._v(_vm._s(_vm.$t('listings.actions.export_xls')))]):_vm._e(),(_vm.showImportButton)?_c('a',{staticClass:"btn",attrs:{"href":_vm.getExcelImportHref()}},[_vm._v(_vm._s(_vm.$t('listings.actions.import_xls')))]):_vm._e()],2):_vm._e()}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "ListActions.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__